<div class="specialist-search-form">

  <!-- Filter Form -->
  <form [formGroup]="filterForm" (ngSubmit)="search()">
    <div class="p-grid p-fluid filter-grid">

      <div class="p-col-6 p-field">
        <label for="providerNumber">Provider Number</label>
        <input id="providerNumber" pInputText formControlName="providerNumber" placeholder="e.g. 1234567A" class="p-inputtext" />
      </div>

      <div class="p-col-6 p-field">
        <label for="firstName">First Name</label>
        <input id="firstName" pInputText formControlName="firstName" placeholder="e.g. John" class="p-inputtext" />
      </div>

      <div class="p-col-6 p-field">
        <label for="middleName">Middle Name</label>
        <input id="middleName" pInputText formControlName="middleName" placeholder="e.g. Michael" class="p-inputtext" />
      </div>

      <div class="p-col-6 p-field">
        <label for="lastName">Last Name</label>
        <input id="lastName" pInputText formControlName="lastName" placeholder="e.g. Smith" class="p-inputtext" />
      </div>

      <div class="p-col-6 p-field">
        <label for="state">State</label>
        <p-dropdown
          id="state"
          formControlName="state"
          [options]="stateOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="All States">
        </p-dropdown>
      </div>


    </div>

    <div class="form-actions">
      <button pButton type="submit" label="Search" icon="pi pi-search" [loading]="loading"></button>
      <button pButton type="button" label="Clear" icon="pi pi-filter-slash" class="p-button-secondary" (click)="clearFilters()"></button>
    </div>
  </form>

  <!-- Results Grid -->
  <div class="results-container" *ngIf="searchPerformed">
    <p-table
      [value]="specialists"
      [loading]="loading"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} specialists"
      styleClass="p-datatable-sm p-datatable-striped">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="firstName">First Name <p-sortIcon field="firstName"></p-sortIcon></th>
          <th pSortableColumn="middleName">Middle Name <p-sortIcon field="middleName"></p-sortIcon></th>
          <th pSortableColumn="lastName">Last Name <p-sortIcon field="lastName"></p-sortIcon></th>
          <th>Provider Number and Address</th>
          <th>States</th>
          <th>Specialties</th>
          <th style="width: 7rem"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-specialist>
        <tr>
          <td>{{ specialist.firstName }}</td>
          <td>{{ specialist.middleName }}</td>
          <td>{{ specialist.lastName }}</td>
          <td>
            <p-dropdown
              [(ngModel)]="specialist.selectedProviderAddress"
              [ngModelOptions]="{ standalone: true }"
              [options]="specialist.providerAddressOptions"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              placeholder="Select provider and address">
            </p-dropdown>
          </td>
          <td>{{ specialist.states }}</td>
          <td>
            <p-dropdown
              [(ngModel)]="specialist.selectedSpecialty"
              [ngModelOptions]="{ standalone: true }"
              [options]="specialist.specialtyOptions"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              placeholder="Select specialty">
            </p-dropdown>
          </td>
          <td>

            <button
              pButton
              type="button"
              label="Select"
              icon="pi pi-check"
              class="p-button-sm p-button-success"
              (click)="selectSpecialist(specialist)">
            </button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="empty-message">No specialists found matching the search criteria.</td>
        </tr>
      </ng-template>

    </p-table>
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer">
    <button pButton type="button" label="Cancel" class="p-button-secondary" (click)="handleCancelClick()"></button>    
  </div>

</div>
